// ========================================
// 📄 src/components/leads/LeadFilters.jsx
// ========================================
import React from "react";
import { Search, Filter } from "lucide-react";
import { LEAD_STATUS, LEAD_SOURCES } from "../../config/constants";

const LeadFilters = ({ filters, onFilterChange }) => {
  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="card mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-5 h-5 text-gray-600" />
        <h3 className="font-semibold text-lg">Filtres</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Recherche */}
        <div className="lg:col-span-2">
          <label className="label">Recherche</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              value={filters.search || ""}
              onChange={(e) => handleChange("search", e.target.value)}
              placeholder="Nom, email, téléphone..."
              className="input-field pl-10"
            />
          </div>
        </div>

        {/* Statut */}
        <div>
          <label className="label">Statut</label>
          <select
            value={filters.status || "all"}
            onChange={(e) => handleChange("status", e.target.value)}
            className="input-field"
          >
            <option value="all">Tous les statuts</option>
            {Object.entries(LEAD_STATUS).map(([key, value]) => (
              <option key={key} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>

        {/* Source */}
        <div>
          <label className="label">Source</label>
          <select
            value={filters.source || "all"}
            onChange={(e) => handleChange("source", e.target.value)}
            className="input-field"
          >
            <option value="all">Toutes les sources</option>
            {LEAD_SOURCES.map((source) => (
              <option key={source} value={source}>
                {source}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Actions */}
      <div className="flex gap-2 mt-4">
        <button
          onClick={() =>
            onFilterChange({ search: "", status: "all", source: "all" })
          }
          className="btn-secondary text-sm"
        >
          Réinitialiser
        </button>
      </div>
    </div>
  );
};

export default LeadFilters;
